import { getCurrentDateObject } from '../helpers/date-helper';
import { toInputDate } from '../helpers/string-format-helper';
import { wallClockToDate, wallClockToHour } from '../helpers/event-helper';

export const formDataEventCreate = (defaultData?: EventDto): FormParams => {
  return {
    items: {
      upperFields: [
        {
          element: 'input',
          type: 'text',
          id: 'title',
          placeHolder: 'Título do evento',
          label: 'Título do evento',
          defaultValue: defaultData ? defaultData.title : null,
        },
        {
          element: 'input',
          type: 'file',
          id: 'image',
          label: 'Adicionar imagem',
        },
        {
          element: 'textarea',
          id: 'description',
          placeHolder: 'Descrição do evento',
          label: 'Descrição do evento',
          rows: 5,
          defaultValue: defaultData ? defaultData.description : null,
        },
      ],
      bottomFields: [
        {
          element: 'input',
          type: 'date',
          id: 'date',
          label: 'Data',
          minDate: defaultData
            ? wallClockToDate(defaultData.startsAt.local)
            : toInputDate(getCurrentDateObject()),
          defaultValue: defaultData ? wallClockToDate(defaultData.startsAt.local) : null,
        },
        {
          element: 'side',
          leftElement: {
            element: 'input',
            type: 'time',
            id: 'startHour',
            label: 'Hora início',
            defaultValue: defaultData ? wallClockToHour(defaultData.startsAt.local) : null,
          },
          rightElement: {
            element: 'input',
            type: 'time',
            id: 'endHour',
            label: 'Hora fim',
            defaultValue: defaultData ? wallClockToHour(defaultData.endsAt.local) : null,
          },
        },
        {
          element: 'input',
          type: 'text',
          id: 'place',
          placeHolder: 'Local',
          label: 'Local',
          defaultValue: defaultData ? defaultData.place : null,
        },
      ],
    },
    style: 'gray',
  };
};
